import { Link } from 'react-router-dom';
import ManhwaCard from '@/components/feature/ManhwaCard';
import { manhwas } from '@/mocks/manhwas';

export default function FeaturedSection() {
  const featured = manhwas.filter((m) => m.rating >= 9.5).slice(0, 4);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6" aria-labelledby="featured-heading">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 id="featured-heading" className="text-xl md:text-2xl font-heading text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">评分最高的韩漫精选，大家都在看</p>
          </div>
          <Link
            to="/category/hot"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((m) => (
            <ManhwaCard key={m.id} manhwa={m} />
          ))}
        </div>
      </div>
    </section>
  );
}